module.exports = __webpack_public_path__ + "static/media/gcdef_100.cfe7f730.ico";